import type { languages } from "monaco-editor";

const invalid = "invalid";
const ws = "white";
const comment = "comment";
const escape = "escape";
const acli = "acli";
const siteOrClient = "site";
const site = siteOrClient;
const client = "client";
const param = "param";
const booleanParam = param;
const actionParam = "action-param";
const actionValue = "action-value";
const nullValue = "null";
const regexValue = "regexp";
const replVar = "var-repl";
const specialVar = "var-special";
const stringValue = "string";
const paramValue = stringValue;
const dq = "punctuation";

const language: languages.IMonarchLanguage = {
  defaultToken: invalid,
  keywords: [],
  reAcli: /acli/,
  reTitleVar: /[a-zA-Z][\w-]+/,
  reCamelVar: /[a-z]\w+/,
  reLowerVar: /[a-z]+/,
  reReplVar: /@@reCamelVar@/,
  reSpecialVar: /@@reCamelVar/,
  reLongParam: /--@reCamelVar/,
  reShortParam: /-[a-z]/,
  reParam: /@reLongParam|@reShortParam/,
  reLongActionParam: /--action/,
  reShortActionParam: /-a/,
  reActionParam: /@reLongActionParam|@reShortActionParam/,
  reRegexParam: /--regex/,
  reNestedParam: /--input|-i|--common|-c/,
  reDqs: /"|""|""""|""""""""/,
  // reDqs: /(?:"")*"/,
  reQuotedString: /[^"]*(?:(?:"")+[^"]*)*/,
  reEol: /\s|\\$|$/,
  tokenizer: {
    root: [
      // Whitespace
      [/\s+/, ws],
      // Comments
      [/#.*$/, comment],
      // EOL escape
      [/\\$/, escape],
      // ACLI command
      [/^(\s*)(@reAcli)(\s+)(@reTitleVar)(\s+)(@reLowerVar)/, [ws, acli, ws, siteOrClient, ws, client]],
      [/^(\s*)(@reAcli)(\s+)(@reTitleVar)/, [ws, acli, ws, siteOrClient]],
      [/^(\s*)(@reAcli)/, [ws, acli]],
      // Sites and clients
      [/^(\s*)(@reTitleVar)(\s+)(@reLowerVar)/, [ws, site, ws, client]],
      [/^(\s*)(@reTitleVar)/, [ws, siteOrClient]],
      // Invalid parameters
      [/(--\w?)(@reEol)/, [invalid, ws]],
      [/(-\w{2,})(@reEol)/, [invalid, ws]],
      // [/(@reNestedParam)(\s+)(@reDqs)(@reQuotedString)(\3)(@reEol)/,
      //   [{token: param}, {token: ws}, {token: "@rematch"}, {token: "@rematch", next: "@push"}, {token: "@rematch", next: "@pop"}, {token: ws}]],
      [
        /(@reNestedParam)(\s+)(@reDqs)/,
        [{ token: param }, { token: ws }, { token: "@rematch", next: "@nestedAction" }],
      ],
      [/(@reRegexParam)(\s+)(@reDqs)/, [{ token: param }, { token: ws }, { token: "@rematch", next: "@nestedRegex" }]],
      [/(@reParam)(\s+)(@reDqs)/, [{ token: param }, { token: ws }, { token: "@rematch", next: "@nestedString" }]],
      // Parameters and values
      [/(@reActionParam)(\s+)(@reCamelVar)/, [actionParam, ws, actionValue]],
      [/(@reRegexParam)(\s+)([^\s]+)/, [param, ws, regexValue]],
      [/(@reParam)(\s+)(null)/, [param, ws, nullValue]],
      [/(@reParam)(\s+)(@reReplVar)/, [param, ws, replVar]],
      [/(@reParam)(\s+)(@reSpecialVar)/, [param, ws, specialVar]],
      [/(@reParam)(\s+)([^-][^\s]*)/, [param, ws, paramValue]],
      // Boolean parameters
      [/@reParam/, booleanParam],
      // Quotes
      [/@reDqs/, { token: dq }],
      [/@reEol/, "@popall"],
    ],
    // TODO: The problem with nested actions here is that we want to consider something like `""` to be a single quote when at
    // a depth == 2 (1-indexed).  So we need some way to know the depth of the stack and then react to that by requiring different
    // quote matching regexps.  I haven't found out how to achieve that yet in Monarch.
    nestedAction: [
      [/(@reDqs)(@reQuotedString)(\1)/, [{ token: dq }, { token: "@rematch", next: "@root" }, { token: "@rematch" }]],
    ],
    nestedRegex: [
      [/(@reDqs)(@reQuotedString)(\1)/, [{ token: dq }, { token: regexValue }, { token: dq, next: "@pop" }]],
    ],
    nestedString: [
      [/(@reDqs)(@reQuotedString)(\1)/, [{ token: dq }, { token: stringValue }, { token: dq, next: "@pop" }]],
    ],
  },
};

export default language;
